import { Trans } from '@lingui/react/macro';
import { cn } from '@repo/videa-components/src/lib/utils';

export const DisplayImageForComparison = ({
  image,
  label,
  loading,
  error,
  isLeftFilter,
}: {
  image?: string;
  label: string;
  loading: boolean;
  error: boolean;
  isLeftFilter: boolean;
}) => {
  return loading ? (
    <div
      className={cn(
        'vai-absolute vai-inset-0 vai-flex vai-items-center vai-justify-center vai-text-sm',
        !isLeftFilter && 'vai-text-blue-600 vai-bg-blue-50',
      )}
    >
      <Trans>Loading...</Trans>
    </div>
  ) : error ? (
    <div
      className={cn(
        'vai-absolute vai-inset-0 vai-flex vai-items-center vai-justify-center vai-text-sm vai-text-red-600',
        !isLeftFilter && ' vai-bg-blue-50',
      )}
    >
      <Trans>Error loading</Trans>
    </div>
  ) : image ? (
    <>
      <img
        src={image}
        alt={label}
        className={cn(
          'vai-w-full vai-h-full vai-object-contain',
          !isLeftFilter && 'vai-bg-blue-50',
        )}
      />
      <div
        className={cn(
          'vai-absolute vai-bottom-0 vai-left-0 vai-right-0 vai-text-white vai-text-xs vai-py-1 vai-px-2 vai-text-center vai-font-semibold',
          !isLeftFilter && 'vai-bg-blue-600',
          isLeftFilter && 'vai-bg-black vai-opacity-50',
        )}
      >
        {label} {!isLeftFilter && '✓'}
      </div>
    </>
  ) : (
    <div
      className={cn(
        'vai-absolute vai-inset-0 vai-flex vai-items-center vai-justify-center vai-text-sm',
        !isLeftFilter && 'vai-bg-blue-50 vai-text-blue-600',
        isLeftFilter && 'vai-bg-black vai-opacity-50 vai-text-white',
      )}
    >
      {label} {!isLeftFilter && '✓'}
      <Trans> Preview</Trans>
    </div>
  );
};
